import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"

//Components
import Loader from "../../components/loader"
import Snack from '../../components/snack'
import NavBar from "./components/nav-bar"

//Extras
import { collection, doc, getDocs, query, setDoc, where } from "firebase/firestore"
import { db } from "../../assets/connections"
import { fontType } from "../../assets/extras"
import { main } from "../../assets/coach-assets/constants/colors"
import { dias } from "../../assets/coach-assets/constants/datas"

//Extras

const CoachAddClass = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const profesor = location.state ? location.state.profesor : null
    const nombre_profesor = location.state ? location.state.nombre_profesor : null

    //Variables de la pagina
    const [variables, setVariables] = useState({
        ref: ref,
        profesor: profesor,
        nombre_profesor: nombre_profesor,
        loading: true,
        classes: [],
        teachers: [],
        dia: "",
        selProfesor: "",
        selProfesorSecundario: ""
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")

            let snack = document.createElement("div")
            snack.classList.add("snack")

            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""

            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funcion que formatea el subitulo
    const formatSubtitle = (dias_clase) => {
        let dias = ""
        dias_clase.map(v => {
            let dia = ""
            let hora = v.de + "-" + v.a
            for (let i = 0; i < 3; i++) {
                dia += v.dia[i]
            }

            if (dias == "") {
                dias = dia + " " + hora
            } else {
                dias += " / " + dia + " " + hora
            }

        })

        return dias
    }

    /**
     * FUNCIONES PARA LA CREACION DE UNA CLASE EXTRACURRICULAR
     */
    //Funcion que guarda la clase
    const onHandleCreate = async () => {
        //Validamos si ya existe alguna clase con la extension EXT de este profesor
        await exists().then(r => {
            if(r === false){
                createClass()
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Ya hay una clase extracurricular creada", "warning")
            }
        })
    }
    //Funcion que valida la clase EXT del profesor
    const exists = async () => {
        let isIn = false
        await getDocs(query(collection(doc(db, variables.ref), "Clases"), where("profesor_clase", "==", variables.profesor))).then(r => {
            r.docs.map(v => {
                let id = v.id.split("-")

                if(id.length > 1){
                    if(id[2] === "EXT"){
                        isIn = true
                    }
                }
            })
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")

            isIn = true
        })

        return new Promise(resolve => {
            resolve(isIn)
        })
    }
    //Funcion que crea la clase
    const createClass = async () => {
        const classData = {
            nombre_clase: "Extracurriculares",
            descripcion_clase: "Clases extracurriculares",
            nombre_profesor: variables.nombre_profesor,
            profesor_clase: variables.profesor
        }

        // Agregar profesor secundario si existe
        if (variables.selProfesorSecundario && variables.selProfesorSecundario !== "") {
            const profesorSecundario = variables.teachers.find(t => t.id === variables.selProfesorSecundario)
            if (profesorSecundario) {
                classData.profesor_clase_secundario = variables.selProfesorSecundario
                classData.nombre_profesor_secundario = profesorSecundario.nombre
            }
        }

        await setDoc(doc(doc(db, variables.ref), "Clases", "XXXXXXXXXXXXXXXXXXXX-" + variables.profesor + "-EXT"), classData).then(r => {
            createHistory("XXXXXXXXXXXXXXXXXXXX-" + variables.profesor + "-EXT")
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    //Funcion que agrega la clase al historial
    const createHistory = async (id) => {
        await setDoc(doc(doc(db, variables.ref), "Historial", id), {
            id: id
        }).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))

            showMessage("Clase creada con exito", "success")
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 2100)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Funcion que obtiene los datos de las clases
    const getData = async () => {
        await getDocs(query(collection(doc(db, variables.ref), "Clases"), where("profesor_clase", "!=", variables.profesor))).then(r => {
            let aux = []
            let profes_id = []
            let profes = []

            r.docs.map(v => {
                if (v.id.split("-").length === 1) {

                    let dias_aux = []
                    v.data().dias_clase.map(v => {
                        dias_aux.push(v.dia)
                    })

                    aux.push({
                        id: v.id,
                        dias: dias_aux,
                        ...v.data()
                    })

                    if (profes_id.length === 0) {
                        profes_id.push(v.data().profesor_clase)
                        profes.push({
                            id: v.data().profesor_clase,
                            nombre: v.data().nombre_profesor
                        })
                    } else {
                        if (!profes_id.includes(v.data().profesor_clase)) {
                            profes_id.push(v.data().profesor_clase)
                            profes.push({
                                id: v.data().profesor_clase,
                                nombre: v.data().nombre_profesor
                            })
                        }
                    }

                }
            })

            setVariables(prev => ({
                ...prev,
                loading: false,
                teachers: profes,
                classes: aux
            }))
        }).catch(e => {
            console.log(e)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Funcion que se ejecuta al presionar una clase
    const onHandlePressed = async (data) => {
        let id = data.id
        delete data.id

        //Primero agregamos la clase a la lista de clases
        await setDoc(doc(doc(db, variables.ref), "Clases", id), data).then(r => {
            setDoc(doc(doc(db, variables.ref), "Historial", id), {
                id: id
            }).then(r => {
                showMessage("Clase creada con exito", "success")
                setTimeout(() => {
                    navigate(-1, { replace: true });
                }, 2000)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Error al crear historial de la clase", "error")
            })
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error al crear la clase", "error")
        })
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            console.log("SI")
            getData()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!variables.loading)
        return (
            <div
                style={{
                    flex: 1,
                    alignItems: "center",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column"
                }}
            >

                <Snack />

                <NavBar
                    title={"AGREGAR CLASE"}
                />

                <p
                    style={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: 10,
                        fontFamily: fontType.title,
                        fontSize: 16,
                        marginBottom: 20,
                    }}
                >
                    Selecciona una clase
                </p>

                {/* Crear clase */}
                <button
                    style={{
                        backgroundColor: main,
                        padding: 15,
                        borderRadius: 5,
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 10,
                        border: "none",
                        cursor: "pointer"
                    }}
                    onClick={() => {
                        setVariables(prev => ({
                            ...prev,
                            loading: true
                        }))

                        onHandleCreate()
                    }}
                >
                    <span
                        style={{
                            color: "white",
                            fontFamily: fontType.title,
                            fontSize: 16,
                        }}
                    >
                        CREAR CLASE
                    </span>
                </button>

                {/* Selección profesor */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: 30,
                        maxWidth: 800
                    }}
                >
                    <div
                        style={{
                            width: "90%",
                            borderWidth: 1,
                            borderRadius: 10,
                            marginTop: 5,
                            borderColor: "#ddd",
                            borderStyle: "solid",
                        }}
                    >
                        <select
                            value={variables.selProfesor}
                            onChange={(e) =>
                                setVariables((prev) => ({
                                    ...prev,
                                    selProfesor: e.target.value,
                                }))
                            }
                            style={{
                                width: "100%",
                                padding: "10px",
                                color: "black",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "none",
                            }}
                        >
                            <option value="">Seleccionar profesor</option>
                            {variables.teachers.map((v) => (
                                <option key={v.id} value={v.id}>
                                    {v.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Selección día */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: 10,
                        maxWidth: 800
                    }}
                >
                    <div
                        style={{
                            width: "90%",
                            borderWidth: 1,
                            borderRadius: 10,
                            marginTop: 5,
                            borderColor: "#ddd",
                            borderStyle: "solid",
                        }}
                    >
                        <select
                            value={variables.dia}
                            onChange={(e) =>
                                setVariables((prev) => ({
                                    ...prev,
                                    dia: e.target.value,
                                }))
                            }
                            style={{
                                width: "100%",
                                padding: "10px",
                                color: "black",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "none",
                            }}
                        >
                            <option value="">Seleccionar día</option>
                            {dias.map((v, idx) => (
                                <option key={idx} value={v}>
                                    {v}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Selección profesor secundario */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: 10,
                        maxWidth: 800
                    }}
                >
                    <div
                        style={{
                            width: "90%",
                            borderWidth: 1,
                            borderRadius: 10,
                            marginTop: 5,
                            borderColor: "#ddd",
                            borderStyle: "solid",
                        }}
                    >
                        <select
                            value={variables.selProfesorSecundario}
                            onChange={(e) =>
                                setVariables((prev) => ({
                                    ...prev,
                                    selProfesorSecundario: e.target.value,
                                }))
                            }
                            style={{
                                width: "100%",
                                padding: "10px",
                                color: "black",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                border: "none",
                            }}
                        >
                            <option value="">Profesor secundario (opcional)</option>
                            {variables.teachers.map((v) => (
                                <option key={v.id} value={v.id}>
                                    {v.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Lista de clases */}
                {
                    (variables.dia === "" && variables.selProfesor === "") ?
                        variables.classes.map((v, i) =>
                            <CardComponent
                                key={i}
                                onHandlePressed={onHandlePressed}
                                nombre_profesor={variables.nombre_profesor}
                                formatSubtitle={formatSubtitle}
                                profesor={variables.profesor}
                                profesorSecundario={variables.selProfesorSecundario}
                                nombreProfesorSecundario={variables.teachers.find(t => t.id === variables.selProfesorSecundario)?.nombre || ""}
                                setVariables={setVariables}
                                v={v}
                            />
                        )
                    : (variables.dia === "" && variables.selProfesor != "") ?
                        variables.classes.filter(v => v.profesor_clase === variables.selProfesor).map((v, i) =>
                            <CardComponent
                                key={i}
                                onHandlePressed={onHandlePressed}
                                nombre_profesor={variables.nombre_profesor}
                                formatSubtitle={formatSubtitle}
                                profesor={variables.profesor}
                                profesorSecundario={variables.selProfesorSecundario}
                                nombreProfesorSecundario={variables.teachers.find(t => t.id === variables.selProfesorSecundario)?.nombre || ""}
                                setVariables={setVariables}
                                v={v}
                            />
                        )
                    : (variables.dia != "" && variables.selProfesor === "") ?
                        variables.classes.filter(v => v.dias.includes(variables.dia)).map((v, i) =>
                            <CardComponent
                                key={i}
                                onHandlePressed={onHandlePressed}
                                nombre_profesor={variables.nombre_profesor}
                                formatSubtitle={formatSubtitle}
                                profesor={variables.profesor}
                                profesorSecundario={variables.selProfesorSecundario}
                                nombreProfesorSecundario={variables.teachers.find(t => t.id === variables.selProfesorSecundario)?.nombre || ""}
                                setVariables={setVariables}
                                v={v}
                            />
                        )
                    :
                        variables.classes.filter(v => v.profesor_clase === variables.selProfesor && v.dias.includes(variables.dia)).map((v, i) =>
                            <CardComponent
                                key={i}
                                onHandlePressed={onHandlePressed}
                                nombre_profesor={variables.nombre_profesor}
                                formatSubtitle={formatSubtitle}
                                profesor={variables.profesor}
                                profesorSecundario={variables.selProfesorSecundario}
                                nombreProfesorSecundario={variables.teachers.find(t => t.id === variables.selProfesorSecundario)?.nombre || ""}
                                setVariables={setVariables}
                                v={v}
                            />
                        )
                }
            </div>
        )
}

const CardComponent = ({
    v,
    profesor,
    nombre_profesor,
    setVariables,
    onHandlePressed,
    formatSubtitle,
    profesorSecundario,
    nombreProfesorSecundario
}) => {
    return (
        <div
            style={{
                width: "90%",
                borderWidth: 1,
                borderStyle: "solid",
                borderRadius: 5,
                padding: 10,
                marginTop: 10,
                marginBottom: 5,
                cursor: "pointer",
                maxWidth: 800
            }}
            onClick={() => {
                let newObject = {
                    ...v,
                    id: v.id + "-" + profesor + "-TEMP",
                    nombre_profesor: nombre_profesor,
                    profesor_clase: profesor,
                    clases_muestra: 0,
                };

                // Agregar profesor secundario si existe
                if (profesorSecundario && profesorSecundario !== "") {
                    newObject.profesor_clase_secundario = profesorSecundario
                    newObject.nombre_profesor_secundario = nombreProfesorSecundario
                }

                setVariables((prev) => ({
                    ...prev,
                    loading: true,
                }));

                setTimeout(() => {
                    onHandlePressed(newObject);
                }, 100);
            }}
        >
            <p
                style={{
                    fontFamily: fontType.title,
                    fontSize: 18,
                    marginBottom: 5,
                }}
            >
                {v.nombre_clase}
            </p>
            <p style={{ fontFamily: fontType.text }}>{formatSubtitle(v.dias_clase)}</p>
            <p
                style={{
                    width: "100%",
                    textAlign: "right",
                    fontFamily: fontType.text
                }}
            >
                {v.nombre_profesor}
            </p>
        </div>

    )
}

export default CoachAddClass